<style src="./ProductFinder.scss" lang="scss" scoped></style>
<template>
  <section class="product-finder">
    <form v-on:submit.prevent>
      <section class="form-box row">
        <textbox
          v-model="searchText"
          label="Buscar produto"
          placeholder="Digite o nome do produto"
          class="textbox"
          :autofocus="true"
          :debounce="300"
          @debounce="searchProduct"
          v-shortkey.focus="['ctrl', 'f']"
          ref="searchBox" />
        <button class="button-config" @click="openQuoteConfig">
          <icon-configuration />
        </button>
      </section>
    </form>

    <product-map
      @item-choosed="itemChoosed"
      @edit-max-price="editMaxPrice"
      @edit-item="openEditItem"
      :list="listResult"
      ref="productMap" />

    <div class="header-search" v-if="listResult.length > 0">
      <page-navigator
        :total-pages="totalPages"
        v-model="paginateSearchParams.actualPage" />
    </div>

    <right-side-panel ref="rspQuoteConfig" title="Configurações de Cotação">
      <quote-configurations />
    </right-side-panel>

    <right-side-panel ref="rspEditMaxPrice" title="Anexar Preço Máximo" width="600px">
      <edit-max-price
        :edit-max-price="editMaxPriceItem"
        @confirmed-edit="maxPriceEdited"/>
    </right-side-panel>

    <right-side-panel ref="rspEditItem" title="Editar Item" width="600px">
      <edit-item
        :item-details="editItem.details"
        :item-idx="editItem.idx"
        @confirmed-edit="refreshSearch"/>
    </right-side-panel>
  </section>
</template>

<script>
import { Textbox, PageNavigator } from '@/components/primitives'
import { IconConfiguration } from '@/components/primitives/icons'
import ProductMap from '../product-map/ProductMap'
import { SearchProductInStock } from '@/brain/record/stock'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import { QuoteConfigurations } from '@/view/item-association/components/right-panel'
import EditMaxPrice from '@/view/record/cmed/components/right-panel/edit-max-price/EditMaxPrice'
import EditItem from '@/view/record/stock/components/edit-item/EditItem'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductFinder',
  components: {
    ProductMap,
    Textbox,
    IconConfiguration,
    QuoteConfigurations,
    PageNavigator,
    RightSidePanel,
    EditMaxPrice,
    EditItem
  },
  data () {
    return {
      searchText: '',
      oldSearchText: null,
      listResult: [],
      searchRequestCount: 0,
      paginateSearchParams: {
        actualPage: 0,
        offsetPage: 20,
        searchText: null
      },
      totalPages: 0,
      editMaxPriceItem: {
        item: null,
        itemIndex: null
      },
      editItem: {
        details: null,
        idx: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      searchTip: ['ItemAssociation/GET_SEARCH_TIP']
    })
  },
  watch: {
    searchRequestCount (pRequestValue) {
      this.$refs.productMap.setSearchMode(pRequestValue)
    },
    paginateSearchParams: {
      handler () {
        this.requestProduct()
      },
      deep: true
    },
    searchTip (pValue) {
      if (!pValue) return false
      this.searchText += pValue + ' '
      this.searchProduct()
      this.$store.commit('ItemAssociation/SET_SEARCH_TIP', ' ')
    }
  },
  methods: {
    refreshSearch () {
      this.requestProduct()
    },
    async searchProduct () {
      if (!this.searchText || this.searchText.length < 1) {
        this.listResult = []
        this.oldSearchText = null
      } else if (this.searchText !== this.oldSearchText) {
        this.paginateSearchParams.actualPage = 0
        this.paginateSearchParams.searchText = this.searchText
      }
    },
    async requestProduct () {
      try {
        this.searchRequestCount++
        const searchResult = await SearchProductInStock(this.paginateSearchParams)
        this.oldSearchText = this.paginateSearchParams.searchText
        if (searchResult && searchResult.result.length > 0) {
          this.listResult = searchResult.result
          this.totalPages = Math.round(searchResult.count.totalCount / this.paginateSearchParams.offsetPage)
        } else {
          this.listResult = []
          this.totalPages = 0
        }
      } catch (err) {
      } finally {
        this.searchRequestCount--
      }
    },
    itemChoosed () {
      if (this.$store.getters['ItemAssociation/GET_CONFIG']('cleanSearchAfterQuote')) this.cleanList()
      if (this.$store.getters['ItemAssociation/GET_CONFIG']('jumpToNextItemWhenQuote')) this.goToNextItem()
    },
    cleanList () {
      this.searchText = ''
      this.oldSearchText = null
      this.listResult = []
      this.paginateSearchParams.actualPage = 0
      this.paginateSearchParams.searchText = 0
      this.$refs.searchBox.$el.focus()
    },
    goToNextItem () {
      this.$store.dispatch('ItemAssociation/NAVIGATE_MAP', 1)
    },
    openQuoteConfig () {
      this.$refs.rspQuoteConfig.showPanel()
    },
    navigateShortcut (pDirection) {
      pDirection.stopPropagation()
      switch (pDirection.srcKey) {
        case 'go-next-page':
          this.goToNextPage()
          break
        case 'go-prev-page':
          this.goToPreviousPage()
          break
        default:
          break
      }
    },
    editMaxPrice ({ item, itemIndex }) {
      this.editMaxPriceItem.item = item
      this.editMaxPriceItem.itemIndex = itemIndex
      this.$refs.rspEditMaxPrice.showPanel()
    },
    maxPriceEdited () {
      this.requestProduct()
    },
    openEditItem ({ item, itemIdx }) {
      this.editItem.details = { ...item }
      this.$refs.rspEditItem.showPanel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/product-finder/ProductFinder.vue